import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { OEditorialHighlight as OEditorialHighlightComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

export const OEditorialHighlightConfig = {
  emptyLabel: 'OEditorialHighlight',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-editorial-highlight`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OEditorialHighlight = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div
      data-testid="o-editorial-highlight-comp"
      data-component-name="o-editorial-highlight"
      id={componentId}
      className={clsx(styleclass)}
    >
      <EditableComponent config={OEditorialHighlightConfig} {...props}>
        <OEditorialHighlightComp {...props} />
      </EditableComponent>
    </div>
  );
};
